import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'
import { queryParam } from '@/config/queryParam.js'

export const getDepartments = (filters) => fetchApi.get(constants.ENDPOINT_DEPARTMENTS + queryParam(filters))
export const getUnitDepartmentReviews = (id) => fetchApi.get(constants.ENDPOINT_DEPARTMENTS + `/reviews_statistics/${id}`)
